import { FacilityPosition } from './facility-position.model';
import { PagedRequestDto } from './paged-request.model';
import { Role } from './role.model';

export type FacilityRoleNested = Pick<
  Role,
  'id' | 'name' | 'permissionTypeIds'
>;

export interface FacilityAdmin {
  id: string;
  facilityId: string;
  name: string;
  email: string;
  role: string;
  position: string;
  status: 'active' | 'inactive';
  rehireEligible?: boolean;
  terminationDate?: string;
  terminationReason?: string;
}

export interface FacilityAdminsRequest extends PagedRequestDto {
  facilityId?: string;
  isActive?: boolean;
  isTerminated?: boolean;
  positionId?: number;
  roleId?: number;
}

export interface CreateFacilityAdmin {
  positionId: number;
  roleId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  hireDate?: string; // DateOnly format: YYYY-MM-DD
  hourlyWage?: number;
  salary?: number;
  employmentTypeId?: number;
  isActive: boolean;
}
export interface FacilityAdmins {
  facilityId: string;
  userId: string;
  positionId?: number;
  roleId?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  hireDate?: string;
  hourlyWage?: number;
  salary?: number;
  employmentTypeId?: number;
  employmentTypeName?: string;
  isActive: boolean;
  terminationDate?: string;
  terminationReason?: string;
  isRehireEligible: boolean;
  position?: FacilityPosition;
  role?: Role;
  id: string;
  createdAt: string;
  updatedAt: string;
  invitationSent?: boolean; // Indicates if invitation email has been sent
  invitationAccepted?: boolean; // Indicates if invitation has been accepted by the user
  invitationSentAt?: string; // Timestamp of when the invitation was sent
}

export interface UpdateFacilityAdmin {
  positionId?: number;
  roleId?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  hireDate?: string;
  hourlyWage?: number;
  salary?: number;
  employmentTypeId?: number;
  isActive: boolean;
}

export interface TerminateFacilityAdmin {
  terminationDate: string; // DateOnly format: YYYY-MM-DD
  reason: string; // max 500 chars
  isRehireEligible: boolean;
}
